import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const AssociateSettingsRoutes = defineRoute({
    update: {
        route: {
            path: "/associate-settings",
            component: () => loadView(import("./AssociateSettingsUpdate.vue")),
        },
    },
});
